import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Tournament, TournamentRoundTeam, TournamentTeam } from '@mtgame/core';
import { getHeaderHeight } from '@utils/layout';
import { getTeamPageRoute } from '@config/routes';

@Component({
  selector: 'mtg-volleyball-standings',
  templateUrl: './volleyball-standings.component.html',
  styleUrls: ['./volleyball-standings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VolleyballStandingsComponent {
  @Input()
  tournament: Tournament;
  @Input()
  teams: TournamentRoundTeam[];
  headerHeight = getHeaderHeight();

  getTeamPageRoute(teamId: number): string[] {
    return getTeamPageRoute(teamId);
  }

  getGamesCount(team: TournamentRoundTeam, score: number, missed: number): number {
    return team.gamesByScoreCount && team.gamesByScoreCount[`${score}_${missed}`] || 0;
  }

  getRatio(x, y) {
    if (y === 0) {
      return 0;
    }
    return Math.round(100 * x / y) / 100;
  }
}
